"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TabContext = void 0;
exports.TabProvider = TabProvider;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _constants = require("../../../@constants");
var _hooks = require("../../../@hooks");
var _functions = require("../../../@functions");
var _Login = _interopRequireDefault(require("../tabs/Login"));
var _PasswordRecovery = _interopRequireDefault(require("../tabs/PasswordRecovery"));
var _Register = _interopRequireDefault(require("../tabs/Register"));
var _ExternalRegister = _interopRequireDefault(require("../tabs/ExternalRegister"));
var _RecoveryEmailSent = _interopRequireDefault(require("../tabs/RecoveryEmailSent"));
var _RedefinePassword = _interopRequireDefault(require("../tabs/RedefinePassword"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var tabs = {
  login: _Login["default"],
  forgotPassword: _PasswordRecovery["default"],
  register: _Register["default"],
  externalRegister: _ExternalRegister["default"],
  recoveryEmailSent: _RecoveryEmailSent["default"],
  redefinePassword: _RedefinePassword["default"]
};

/**
 * @typedef Tab
 * @type {keyof tabs}
 */

var TabContext = (0, _react.createContext)({
  /**@type {"collectame" | "dokplus" | "indexia" | "workflux" | "appcenter-customer" | "workflux-portal"}*/
  app: 'collectame',
  /** @type {Tab} */
  tab: 'login',
  /**
   * @param {Tab} tab
   * @param {any=} props
   **/
  setTab: function setTab() {
    console.log('setTab');
  },
  /** @type {(props: any) => JSX.Element} */
  TabComponent: tabs.login,
  /** @type {any} */
  tabProps: {},
  coverSrc: '',
  coverLoaded: false
});
exports.TabContext = TabContext;
function TabProvider(_ref) {
  var children = _ref.children,
    app = _ref.app,
    auth = _ref.auth;
  /** @type {[Tab, React.Dispatch<React.SetStateAction<Tab>>]} */
  var _useState = (0, _react.useState)('login'),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    tab = _useState2[0],
    setTab = _useState2[1];
  var _useState3 = (0, _react.useState)(''),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    tabProps = _useState4[0],
    setTabProps = _useState4[1];
  var _useWhitelabel = (0, _hooks.useWhitelabel)(auth),
    whitelabelLoading = _useWhitelabel.loading,
    whitelabel = _useWhitelabel.whitelabel,
    whitelabelLicense = _useWhitelabel.whitelabelLicense;
  var whitelabelIsEnabled = !!whitelabelLicense && ['paid', 'free'].includes(whitelabelLicense.status);
  var appWhitelabel = whitelabelIsEnabled && whitelabel && whitelabel[app] ? whitelabel[app] : undefined;
  var covers = {
    login: (appWhitelabel === null || appWhitelabel === void 0 ? void 0 : appWhitelabel.loginBackgroundImage) || _constants.coverImages[app].login,
    forgotPassword: _constants.coverImages[app].forgotPassword,
    register: _constants.coverImages[app].register,
    externalRegister: _constants.coverImages[app].register,
    recoveryEmailSent: _constants.coverImages[app].recoveryEmailSent,
    redefinePassword: _constants.coverImages[app].redefinePassword
  };
  var TabComponent = tabs[tab];
  var coverSrc = covers[tab];

  /**
   * @param {Tab} newTab
   * @param {any} tabProps
   * */
  var handleTabChange = function handleTabChange(newTab) {
    var tabProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    setTab(newTab);
    setTabProps(tabProps);
  };
  return /*#__PURE__*/_react["default"].createElement(TabContext.Provider, {
    value: {
      tab: tab,
      setTab: handleTabChange,
      TabComponent: TabComponent,
      tabProps: tabProps,
      coverSrc: coverSrc,
      coverLoaded: !whitelabelLoading
    }
  }, children);
}
TabProvider.propTypes = {
  app: _propTypes["default"].string.isRequired,
  auth: _propTypes["default"].any.isRequired,
  children: _propTypes["default"].node.isRequired
};